var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12 19.5 3.75 12 3.75C4.5 3.75 0 12 0 12C0 12 4.5 20.25 12 20.25C19.5 20.25 24 12 24 12ZM1.75905 12C1.84444 11.8698 1.94181 11.7252 2.05091 11.5686C2.55324 10.8479 3.29446 9.88936 4.24816 8.93566C6.18155 7.00227 8.82093 5.25 12 5.25C15.1791 5.25 17.8185 7.00227 19.7518 8.93566C20.7055 9.88936 21.4468 10.8479 21.9491 11.5686C22.0582 11.7252 22.1556 11.8698 22.2409 12C22.1556 12.1302 22.0582 12.2748 21.9491 12.4314C21.4468 13.1521 20.7055 14.1106 19.7518 15.0643C17.8185 16.9977 15.1791 18.75 12 18.75C8.82093 18.75 6.18155 16.9977 4.24816 15.0643C3.29446 14.1106 2.55324 13.1521 2.05091 12.4314C1.94181 12.2748 1.84444 12.1302 1.75905 12Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM6.75 12C6.75 9.1005 9.1005 6.75 12 6.75C14.8995 6.75 17.25 9.1005 17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4d0f96b8211fc4da41d813eea2580102.svg";
export { ForwardRef as ReactComponent };